import type { CSSProperties } from "react";
import { makeStyles } from "@fluentui/react-components";
import { Add16Regular } from "@fluentui/react-icons";
import { FuiButton } from "@/components/fui-control";

const useStyles = makeStyles({
  wrap: {
    display: "flex",
    justifyContent: "flex-start",
    marginTop: "4px",
    "@media print": {
      display: "none !important",
    },
  },
  tableCell: {
    padding: "2px 8px",
    "@media print": {
      display: "none !important",
    },
  },
});

export interface InlineGhostRowProps {
  label: string;
  onClick: () => void;
  asTableRow?: boolean;
  colSpan?: number;
  className?: string;
  style?: CSSProperties;
}

export function InlineGhostRow({
  label,
  onClick,
  asTableRow = false,
  colSpan = 1,
  className,
  style,
}: InlineGhostRowProps) {
  const styles = useStyles();
  const button = (
    <div className={styles.wrap} style={style} data-print-hide="" data-ghost-row="">
      <FuiButton appearance="subtle" icon={<Add16Regular />} onClick={onClick} className={className}>
        {label}
      </FuiButton>
    </div>
  );

  if (asTableRow) {
    return (
      <tr data-print-hide="" data-ghost-row="">
        <td colSpan={colSpan} className={styles.tableCell}>
          {button}
        </td>
      </tr>
    );
  }

  return button;
}
